import React from "react";
import Tooltip, { TooltipProps } from "@mui/material/Tooltip";

interface CustomTooltipProps extends Omit<TooltipProps, "title"> {
  title: React.ReactNode;
}

const PRIMARY_BG_COLOR = "#013954";

const CustomTooltip: React.FC<CustomTooltipProps> = ({ title, children, ...props }) => {
  return (
    <Tooltip
      title={title}
      placement="left"
      arrow
      slotProps={{
        tooltip: {
          sx: {
            bgcolor: PRIMARY_BG_COLOR,
            color: "#fff",
            fontSize: "0.875rem",
            fontWeight: 500,
          },
        },
        arrow: {
          sx: {
            color: PRIMARY_BG_COLOR,
          },
        },
      }}
      {...props}
    >
      {children}
    </Tooltip>
  );
};

export default CustomTooltip;
